var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"pre-loader",class:_vm.size},[_vm._m(0),_c('div',{staticClass:"buffer-category"})]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buffer-hero"},[_c('div',{staticClass:"buffer-title"}),_c('div',{staticClass:"buffer-line"}),_c('div',{staticClass:"buffer-line"})])
}]

export { render, staticRenderFns }